import { useHistory } from 'react-router-dom';
import { useCompany } from './contexts/CompanyContext';
import { useConfig } from './contexts/ConfigContext';
import { useUser } from './contexts/UserContext';
import React, { useEffect } from 'react';
import useAuth from './hooks/useAuth';
import { Spin } from 'antd';
import { app, contentPath, modules, isViewAllowed } from './config/const';

const navOptions = [
  modules.Dashboard,
  modules.ChartOfAccounts,
  modules.JournalEntries,
  modules.TrialBalance,
  modules.GeneralLedger,
  modules.IncomeStatement,
  modules.AccountingSettings,
];

function App() {
  const params = new URLSearchParams(window.location.search);
  const session = params.get('session') || localStorage.getItem('session') || "";
  const companyUid = params.get('company') || "";
  const { updateConfig } = useConfig();
  const { updateCompany } = useCompany();
  const { updateUser } = useUser();
  const history = useHistory();

  const fingerprint = "DEFAULT_FP";
  const { tokenData } = useAuth.useToken('authCsrfToken', session, null);
  const { data: baseData } = useAuth.useLoadBase(tokenData, { session, fingerprint, company: companyUid, module: "INICIO" });
  const { data: indexData } = useAuth.useIndex(tokenData, {
    session,
    company: companyUid,
    module: "INICIO"
  });

  useEffect(() => {
    if (baseData && indexData?.user) {
      updateConfig({
        showProgress: false,
        key: baseData.key || tokenData?.key,
        session,
        token: tokenData?.token?.uid
      });

      if (baseData.status === 401 && baseData.redirect) {
        window.location.href = baseData.redirect;
        return;
      }

      const defaultCompany = indexData.companies?.find((comp: any) =>
        indexData.permissions?.some((el: any) => el.key.toUpperCase().startsWith(app.Accounting) && el.company_id === comp.id) &&
        indexData.modules?.some((mod: any) => mod.app?.toUpperCase() === app.Accounting && mod.company_id === comp.id)
      ) ?? indexData.companies?.find((comp: any) =>
        indexData.permissions?.some((el: any) => el.key.toUpperCase().startsWith(app.Accounting) && el.company_id === comp.id)
      ) ?? indexData.companies?.find((comp: any) =>
        indexData.modules?.some((mod: any) => mod.app?.toUpperCase() === app.Accounting && mod.company_id === comp.id)
      ) ?? indexData.companies?.[0];

      const currentCompany = companyUid ? (indexData.companies?.find((comp: any) => comp.uid === companyUid) ?? defaultCompany) : defaultCompany;

      if (currentCompany) {
        updateCompany({ current: { ...currentCompany, uid: currentCompany.uid || companyUid } });
      }

      const views: string[] = (indexData.permissions || [])
        .filter((el: any) => el.type === 'VIEW' && (!currentCompany || el.company_id === currentCompany.id))
        .map((el: any) => el.key);

      updateUser({
        ...indexData.user,
        permissions: {
          views,
          actions: (indexData.permissions || [])
            .filter((el: any) => el.type === 'ACTION' && (!currentCompany || el.company_id === currentCompany.id))
            .map((el: any) => el.key)
        },
        roles: indexData.permissions || []
      });

      // Navigate to dashboard or first available permitted module
      const isDefaultAllowed = isViewAllowed(modules.Dashboard, views);
      if (isDefaultAllowed) {
        history.push(contentPath[modules.Dashboard]);
      } else {
        const firstAvailable = navOptions.find(key => isViewAllowed(key, views));
        if (firstAvailable) {
          history.push(contentPath[firstAvailable]);
        } else {
          history.push('/sorry');
        }
      }
    }
  }, [tokenData, baseData, indexData, companyUid, history, session, updateCompany, updateConfig, updateUser]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', background: '#f5f7fb', flexDirection: 'column', gap: 16 }}>
      <Spin size="large" />
      <span style={{ color: '#666', fontSize: 14 }}>Cargando Módulo de Contabilidad...</span>
    </div>
  );
}

export default App;
